import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
    form: {
        marginBottom: '40px',
    },
    gridWith:{
        width: '100%'
    }
}))